// TODO: REMOVE — replaced by useStoryCardsFeedQuery in LatestsStoryCards; no longer used
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { StoryCard } from '../services';
import { addCard, deleteCard, editCard, getStoryFeedHandler } from './common';

interface LatestsStoryCardsFeedState {
  isFetched: boolean;
  storyFeed: StoryCard[];
  storyId: number;
}

const initialState: LatestsStoryCardsFeedState = {
  isFetched: false,
  storyFeed: [],
  storyId: 0,
};

export const getLatestsStoryCardsFeed = createAsyncThunk(
  'latestsStoryCardsFeed',
  getStoryFeedHandler
);

const LatestsStoryCardsFeedSlice = createSlice({
  name: 'latestsStoryCardsFeedSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLatestsStoryCardsFeed.fulfilled, (state, action) => {
        const { items, storyId } = action.payload;

        state.isFetched = true;
        state.storyFeed = items;
        state.storyId = storyId;
      })
      .addCase(addCard, (state, action) => {
        const { storyId } = action.payload;

        if (state.storyId !== storyId) {
          return;
        }

        state.storyFeed.unshift(action.payload);
      })
      .addCase(editCard, (state, action) => {
        const { id: storyCardId } = action.payload;

        const cardIndex = state.storyFeed.findIndex(({ id }) => id === storyCardId);

        if (cardIndex === -1) {
          return;
        }

        state.storyFeed[cardIndex] = action.payload;
      })
      .addCase(deleteCard.fulfilled, (state, action) => {
        const { deleted, storyCardId } = action.payload;

        if (!deleted) {
          return;
        }

        state.storyFeed = state.storyFeed.filter(({ id }) => id !== storyCardId);
      });
  },
});

export default LatestsStoryCardsFeedSlice.reducer;
